import { render, staticRenderFns } from "./BoxAvis.vue?vue&type=template&id=cb9418fa&scoped=true&"
import script from "./BoxAvis.vue?vue&type=script&lang=js&"
export * from "./BoxAvis.vue?vue&type=script&lang=js&"
import style0 from "./BoxAvis.vue?vue&type=style&index=0&id=cb9418fa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9418fa",
  null
  
)

export default component.exports